module.exports = __webpack_public_path__ + "static/19-thumb-ddb10da87078dc6888b178c58b23be51.jpg";